export default __webpack_public_path__ + "locales/de/People.json?hash=956713a0423f7f623df5277324fe3c6a";